import { render, staticRenderFns } from "./recipentInfo.vue?vue&type=template&id=6eeb25c2&scoped=true&"
import script from "./recipentInfo.vue?vue&type=script&lang=js&"
export * from "./recipentInfo.vue?vue&type=script&lang=js&"
import style0 from "./recipentInfo.vue?vue&type=style&index=0&id=6eeb25c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeb25c2",
  null
  
)

export default component.exports